import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { OverviewComponent } from './components/overview/overview.component';
import { PlayerComponent } from './components/player/player.component';
import { NavigationComponent } from './components/navigation/navigation.component';
import { SideComponent } from './components/side/side.component';
import { SearchResultComponent } from './components/search-result/search-result.component';
import { TopStationsComponent } from './components/radio/top-stations/top-stations.component';
import { GenresComponent } from './components/radio/genres/genres.component';
import { CountriesComponent } from './components/radio/countries/countries.component';
import { AboutUsComponent } from './components/about-pages/about-us/about-us.component';
import { ImprintComponent } from './components/about-pages/imprint/imprint.component';
import { NewsComponent } from './components/radio/news/news.component';
import { ListStreamsComponent } from './components/base/list-streams/list-streams.component';
import { SportsComponent } from './components/radio/sports/sports.component';
import { MusicComponent } from './components/radio/music/music.component';
import { SignupComponent } from './components/signup/signup.component';
import { SiteLayoutComponent } from './components/site-layout/site-layout.component';
import { LoginComponent } from './components/login/login.component';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { ListStreamItemComponent } from './components/base/list-stream-item/list-stream-item.component';
import { ConfirmRegistrationComponent } from './components/confirm-registration/confirm-registration.component';
import { LoginWrapperComponent } from './components/login-wrapper/login-wrapper.component';
import { FormErrorsComponent } from './components/base/form-errors/form-errors.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { SettingsModalComponent } from './components/settings-modal/settings-modal.component';
import { FormInputComponent } from './components/base/form-input/form-input.component';
import { AlertBoxComponent } from './components/base/alert-box/alert-box.component';
import { BlockItemDownloadAppComponent } from './components/base/block-item-download-app/block-item-download-app.component';
import { BlockItemCreateAccountComponent } from './components/base/block-item-create-account/block-item-create-account.component';
import { NavBarBrandComponent } from './components/base/nav-bar-brand/nav-bar-brand.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ToastrModule } from 'ngx-toastr';
import { FormComponent } from './components/base/form/form.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';

import { SimpleModalModule } from 'ngx-simple-modal';

import { InfiniteScrollModule } from '@thisissoon/angular-infinite-scroll';
import { TopPodcastsComponent } from './components/podcast/top-podcasts/top-podcasts.component';
import { PodcastDetailComponent } from './components/podcast/podcast-detail/podcast-detail.component';
import { PodcastGenresComponent } from './components/podcast/podcast-genres/podcast-genres.component';
import { PodcastCountriesComponent } from './components/podcast/podcast-countries/podcast-countries.component';
import { PodcastSearchResultComponent } from './components/podcast-search-result/podcast-search-result.component';
import { RadioDetailComponent } from './components/radio/radio-detail/radio-detail.component';

@NgModule({
  declarations: [
    AppComponent,
    OverviewComponent,
    PlayerComponent,
    NavigationComponent,
    SideComponent,
    SearchResultComponent,
    TopStationsComponent,
    GenresComponent,
    CountriesComponent,
    AboutUsComponent,
    ImprintComponent,
    NewsComponent,
    ListStreamsComponent,
    SportsComponent,
    MusicComponent,
    SignupComponent,
    SiteLayoutComponent,
    LoginComponent,
    NotFoundComponent,
    ListStreamItemComponent,
    ConfirmRegistrationComponent,
    LoginWrapperComponent,
    FormErrorsComponent,
    ResetPasswordComponent,
    ChangePasswordComponent,
    SettingsModalComponent,
    FormInputComponent,
    AlertBoxComponent,
    BlockItemDownloadAppComponent,
    BlockItemCreateAccountComponent,
    NavBarBrandComponent,
    FormComponent,
    PrivacyPolicyComponent,
    TermsAndConditionsComponent,
    TopPodcastsComponent,
    PodcastDetailComponent,
    PodcastGenresComponent,
    PodcastCountriesComponent,
    PodcastSearchResultComponent,
    RadioDetailComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    InfiniteScrollModule,
    BrowserAnimationsModule, // required animations module
    SimpleModalModule,
    ToastrModule.forRoot({
      timeOut: 2000,
      maxOpened: 5
    }) // ToastrModule added
  ],
  //Don't forget to add the component to entryComponents section
  entryComponents: [
    TermsAndConditionsComponent
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
